import {
  useCallback 
} from "react"

export const useInquiryAppointment = (props) => {
  const {
    afterSubmit 
  } = props

  const handleSubmit = useCallback(
    async (formState) => {
      const {
        email, phone 
      } = formState.values

      if (afterSubmit) {
        afterSubmit(email, phone)
      }
    },
    [afterSubmit]
  )

  return {
    handleSubmit,
  }
}
